import { useState } from "react";
import HackerAboutMe from "../components/HackerAboutMe";
import HackerProjects from "../components/HackerProject";
import MatrixBackground from "../components/MatrixBackground";
import { motion, AnimatePresence } from "framer-motion";

const Portfolio = () => {
  const [activeTab, setActiveTab] = useState("about");

  const tabs = [
    { id: "about", label: "$ whoami", prefix: "01" },
    { id: "projects", label: "$ ls ~/projects", prefix: "02" },
  ];

  return (
    <div className="min-h-screen font-mono p-6 relative bg-[#050a0e]">
      <MatrixBackground />

      {/* Ambient orb */}
      <div
        className="absolute top-0 right-1/3 w-96 h-96 rounded-full opacity-5 pointer-events-none z-[1]"
        style={{
          background: "radial-gradient(circle, #a855f7, transparent 70%)",
          filter: "blur(80px)",
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Tab bar */}
        <div className="flex justify-center gap-3 mb-10">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn-tab ${
                activeTab === tab.id ? "btn-tab-active" : ""
              }`}
            >
              <span className="text-xs mr-2 opacity-50">{tab.prefix}</span>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            {activeTab === "about" ? <HackerAboutMe /> : <HackerProjects />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Portfolio;
